class SkillsController implements ng.IComponentController {
    constructor() {
        'ngInject';
    }
}

export const skillsComponent : ng.IComponentOptions = {
    controller : SkillsController,
    template :require('./skills.html')
}


// WEBPACK FOOTER //
// ./src/app/modules/skills/skills.component.ts